import GridBackground from "./signin/GridBackground";

export default function Unauthorized() {
  return (<>
    <GridBackground />
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h2>🚫 Access Denied</h2>
      <p>You do not have permission to view this page.</p>
    </div>
  </>
  );
}
